import styled from '@emotion/styled';

const LinkIcon = styled('div')({
  marginBottom: '0.5rem',
});

export default LinkIcon;
